import { apiClient } from '@api/client';

export type CacheSyncSource = 'market-price' | 'news-article';

const SYNC_TIMEOUT_MS = 300_000;

export async function syncCache(source: CacheSyncSource): Promise<unknown> {
  const response = await apiClient.post<unknown>(
    '/cache-sync/trigger',
    { source },
    { timeout: SYNC_TIMEOUT_MS },
  );
  return response.data;
}
